import { Route, Routes } from "react-router-dom";
import Main from "./Main";
import Shop from "./Shop";
import Portal from "./Portal";
import Info from "./Info";
import React from "react";
import HandleRedirect from "./HandleRedirect";
import Conditions from "./Conditions";
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="" element={<Main />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/info" element={<Info />} />
        <Route path="/handle-purchase" element={<HandleRedirect />} />
        <Route path="/terms-and-conditions" element={<Conditions />} />
      </Routes>
    </>
  );
}

export default App;
